"use client";

import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export default function GlobalBackground() {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) return null;

    return (
        <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none select-none bg-white dark:bg-gray-950 transition-colors duration-1000">
            {/* Main Animation Container */}
            <motion.div 
                animate={{ 
                    rotate: [0, 360],
                }}
                transition={{ 
                    duration: 120, 
                    repeat: Infinity, 
                    ease: "linear" 
                }}
                className="absolute inset-[-50%]"
            >
                {/* Orb 1: Indigo/Violet - Large & Fast */}
                <motion.div
                    animate={{
                        x: ["-15%", "15%", "-5%", "-15%"],
                        y: ["-10%", "20%", "5%", "-10%"],
                        scale: [1, 1.2, 0.9, 1],
                    }}
                    transition={{
                        duration: 20,
                        repeat: Infinity,
                        ease: "easeInOut",
                    }}
                    className="absolute top-[10%] left-[10%] w-[70vmax] h-[70vmax] rounded-full bg-indigo-500/20 dark:bg-indigo-600/15 blur-[100px]"
                />

                {/* Orb 2: Purple/Pink - Mid size & Slow */}
                <motion.div
                    animate={{
                        x: ["10%", "-20%", "5%", "10%"],
                        y: ["20%", "-10%", "10%", "20%"],
                        scale: [1, 0.8, 1.1, 1],
                    }}
                    transition={{
                        duration: 35,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: 1,
                    }}
                    className="absolute bottom-[10%] right-[10%] w-[60vmax] h-[60vmax] rounded-full bg-purple-500/15 dark:bg-purple-600/15 blur-[120px]"
                />

                {/* Orb 3: Cyan/Blue - Dynamic */}
                <motion.div
                    animate={{
                        x: ["-20%", "20%", "-10%", "-20%"],
                        y: ["40%", "-40%", "10%", "40%"],
                    }}
                    transition={{
                        duration: 25,
                        repeat: Infinity,
                        ease: "easeInOut",
                    }}
                    className="absolute top-[30%] left-[40%] w-[50vmax] h-[50vmax] rounded-full bg-cyan-400/15 dark:bg-cyan-500/10 blur-[80px]"
                />
            </motion.div>

            {/* Subtle Static Grid for technical depth */}
            <div className="absolute inset-0 bg-[radial-gradient(rgba(99,102,241,0.05)_1px,transparent_1px)] bg-[size:50px_50px] dark:bg-[radial-gradient(rgba(99,102,241,0.08)_1px,transparent_1px)] opacity-40 shadow-inner" />
            
            {/* Grain overlay for premium texture */}
            <div className="absolute inset-0 opacity-[0.03] dark:opacity-[0.04] pointer-events-none bg-[url('/noise.svg')] brightness-100 contrast-150" />
        </div>
    );
}
